/* eslint-disable no-useless-computed-key */
import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Slide, Switch, Tooltip, Typography, Divider } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import ButtonCom from '../../../components/button/ButtonCom';
import InputControl from '../../../components/input/InputControl';
import Card from '../../../components/layout/Card';
import TransitionsModal from '../../../components/modal/Modal';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import { colors, fonts } from '../../../utils';
import EditIcon from '@mui/icons-material/Edit';
import VrpanoIcon from '@mui/icons-material/Vrpano';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import { setAllSliders } from '../../../redux/slices/sliders/sliders';
import { successNotify } from '../../../utils/helper';

const styles = {
	box: {
		border: "1px solid lightgrey",
		padding: "3rem",
		width: "100%",
		marginTop: "2em",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	slide: {
		width: "200px",
		height: "200px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		margin: "2em",
		border: "1px solid lightgrey",
		padding: "10px"

	},
	img: {
		width: "100%",
		margin: "auto"
	},
	slider: {
		display: "flex",
		alignItems: "center",

	}

};

const Slider = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { sliders } = useSelector((state) => state?.sliders);
	const { slides } = useSelector((state) => state?.slides);

	const [selectedFiles, setSelectedFiles] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [showTxtOnWeb, setShowTxtOnWeb] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [modalName, setModalName] = useState("");
	const [bannerImage, setBannerImage] = useState("");
	const [bannerStatus, setBannerStatus] = useState(false);
	const fileInputRef = useRef(null);
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		name: '',
		description: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});

	// Tutorial Video State
	const [tutorialVideos, setTutorialVideos] = useState([]);
	const [tutorialVideoFormData, setTutorialVideoFormData] = useState({
		title: '',
		video_url: '',
	});
	const [openTutorialModal, setOpenTutorialModal] = useState(false);
	const [isEditingTutorial, setIsEditingTutorial] = useState(false);
	const [isLoadingTutorialModal, setIsLoadingTutorialModal] = useState(false);




	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false)
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getSliders = async () => {
		try {

			await Api.get(`${endPoints?.sliders?.getSliders}/all`, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllSliders(
							response?.data?.data?.sliders?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								name: d?.name,
								description: d?.description,
								dt: d?.dt,
								is_show_text: d?.is_show_text,
								is_enabled: d?.is_enabled,
							})
							),
						),
					);
					// const { page, limit, totalPages, totalRecords } = response?.data?.data?.course?.pagination;
					// setCurrentParams({ page, limit, totalPages, totalRecords });
				})
				.catch((error) => {
					console.log(error)
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			console.log(err)
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};
	const getBannerImage = async () => {
		try {
			await Api.post(`${endPoints?.slides?.getSlides}`, {
				id: 34,
				is_modal: true,
				// slider_id: null,

			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					if (response?.data?.data?.slides) {

						setBannerImage(response?.data?.data?.slides[0].image);
						setBannerStatus(response?.data?.data?.slides[0]?.is_enabled)
					}

				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};


	const handleDeleteSlider = async () => {
		// 	}, {
		// 		headers: {
		// 			'xt-user-token': null
		// 		}
		// 	})
		try {

			await Api.post(endPoints?.sliders?.delete, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Slider Deleted Successfully")
					handleCloseDeleteModal();
					getSliders();

				})
				.catch((error) => {

				});

		} catch (err) {
			console.log(err)
		}
	};
	const handleCreateSliderModal = () => {
		setModalName("Create Slider")
		setIsEditing(false);
		setFormData({ name: '', description: '' })
		setOpenModal(true)
	};
	const handleEditSliderModal = (val) => {
		setModalName("Edit Slider")
		setIsEditing(true);
		setFormData({ name: val.name, description: val.description, id: val.id, is_enabled: val.is_enabled })
		setShowTxtOnWeb(val.is_show_text)
		setOpenModal(true)
	};


	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id })
		setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		setFormData({ name: '', description: '' })
		setOpenDeleteModal(false)
	};

	// const handleSwitchClick = (event) => {
	// 	event.stopPropagation();
	// };
	const handleChangeTableSwitch = async (event, val) => {

		const { name, description, id } = val;
		let data = {
			name, description, id,
			is_enabled: event.target.checked,
		};

		await Api.post(endPoints?.sliders?.delete, { id: id }, {
			headers: {
				'xt-user-token': null
			}
		})
			.then((response) => {
				handleCloseModal();
				getSliders();
				successNotify("Slider Updated Successfully")

			})
			.catch((error) => {

			});

	};
	const handleChangeBannerSwitch = (event) => {
		setBannerStatus(event.target.checked);

	};

	const handleSubmit = async () => {
		setIsLoadingModal(true)
		if (!isEditing) {


			try {

				await Api.post(endPoints?.sliders?.create, {
					name: formData?.name,
					description: formData?.description,
					is_show_text: showTxtOnWeb,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getSliders();
						successNotify("Slider Created Successfully")
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});

			} catch (err) {
				console.log(err)
			}

		} else {


			try {

				await Api.post(endPoints?.sliders?.update, {
					id: formData?.id,
					name: formData?.name,
					description: formData?.description,
					is_enabled: formData?.is_enabled,
					is_show_text: showTxtOnWeb
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getSliders();
						successNotify("Slider Updated Successfully")
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});

			} catch (err) {
				console.log(err)
			}
		}
	};
	const handleBannerModal = async () => {
		getBannerImage();
		setModalName("Edit Banner");
		setIsEditing(false);
		setOpenModal(true);
	};

	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false);
					setBannerImage(response.data.data.link);
					successNotify("Image Uploaded Successfully");

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');

		}
	};
	const handleSubmitBanner = async () => {
		setIsLoadingModal(true)


		try {

			await Api.post(endPoints?.slides?.update, {
				id: 34,
				slider_id: null,
				image: bannerImage,
				is_enabled: bannerStatus,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					handleCloseModal();
					successNotify("Banner Updated Successfully")
					setIsLoadingModal(false)
				})
				.catch((error) => {

				});

		} catch (err) {
			console.log(err)
		}


	};

	// Tutorial Video Handlers
	const handleTutorialVideoChange = (e) => {
		setTutorialVideoFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getTutorialVideos = async () => {
		try {
			await Api.get(`${endPoints?.tutorialVideo?.fetch}/all`, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					if (response?.data?.data?.tutorialVideos) {
						setTutorialVideos(response?.data?.data?.tutorialVideos);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		} catch (err) {
			console.log(err);
		}
	};

	const handleCreateTutorialModal = () => {
		setIsEditingTutorial(false);
		setTutorialVideoFormData({ title: '', video_url: '' });
		setOpenTutorialModal(true);
	};

	const handleEditTutorialModal = (val) => {
		setIsEditingTutorial(true);
		setTutorialVideoFormData({
			id: val.id,
			title: val.title,
			video_url: val.video_url,
			is_enabled: val.is_enabled
		});
		setOpenTutorialModal(true);
	};

	const handleCloseTutorialModal = () => {
		setOpenTutorialModal(false);
		setIsEditingTutorial(false);
	};

	const handleSubmitTutorial = async () => {
		setIsLoadingTutorialModal(true);
		if (!isEditingTutorial) {
			try {
				await Api.post(endPoints?.tutorialVideo?.create, {
					title: tutorialVideoFormData?.title,
					video_url: tutorialVideoFormData?.video_url,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseTutorialModal();
						getTutorialVideos();
						successNotify("Tutorial Video Created Successfully");
						setIsLoadingTutorialModal(false);
					})
					.catch((error) => {
						setIsLoadingTutorialModal(false);
					});
			} catch (err) {
				console.log(err);
				setIsLoadingTutorialModal(false);
			}
		} else {
			try {
				await Api.post(endPoints?.tutorialVideo?.update, {
					id: tutorialVideoFormData?.id,
					title: tutorialVideoFormData?.title,
					video_url: tutorialVideoFormData?.video_url,
					is_enabled: tutorialVideoFormData?.is_enabled,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseTutorialModal();
						getTutorialVideos();
						successNotify("Tutorial Video Updated Successfully");
						setIsLoadingTutorialModal(false);
					})
					.catch((error) => {
						setIsLoadingTutorialModal(false);
					});
			} catch (err) {
				console.log(err);
				setIsLoadingTutorialModal(false);
			}
		}
	};

	const handleChangeTutorialSwitch = async (event, val) => {
		const { title, video_url, id } = val;
		let data = {
			title, video_url, id,
			is_enabled: event.target.checked,
		};

		await Api.post(endPoints?.tutorialVideo?.update, data, {
			headers: {
				'xt-user-token': null
			}
		})
			.then((response) => {
				getTutorialVideos();
				successNotify("Tutorial Video Updated Successfully");
			})
			.catch((error) => {
			});
	};

	useEffect(() => {
		getSliders();
		getTutorialVideos();

	}, [])


	return (
		<>




			<Card margin='3rem 1.5rem' padding='3rem'>
				{/* Slider Section */}
				<Flex jc='space-between' ai='center' mb='1rem'>
					<Typography variant="h5" className='font-face-R' sx={{ fontWeight: 'bold' }}>
						Slider
					</Typography>
					<ButtonCom onClickHandler={handleCreateSliderModal} btnTitle={"Create"} />
				</Flex>
				<Divider sx={{ mb: 2 }} />
				{sliders?.map((val) => {

					return <>

						<Slide direction="right" in={sliders?.length > 0} mountOnEnter unmountOnExit>

							<Box style={styles.box}>
								<Box>
									<Typography className='font-face-R' variant="h4">{val.name}</Typography>
									<Typography fontSize={12} className='font-face-R' variant="body2">{val.description}</Typography>
								</Box>

								<Box>

									<Box>
										{/* <ButtonCom onClickHandler={() => handleEditSliderModal(val)} btnTitle={<EditIcon fontSize='large'/>} /> */}
										{/* <ButtonCom onClickHandler={() => handleOpenDeleteModal(val)} btnTitle={<DeleteIcon fontSize='large' color='error'/>} /> */}
										<Tooltip title='Status'><Switch onChange={(event) => handleChangeTableSwitch(event, val)} checked={val?.is_enabled} name='enabled' /></Tooltip>
										<Tooltip title='Edit'><Button onClick={() => handleEditSliderModal(val)}  ><EditIcon sx={{ fontSize: "32px" }} fontSize='large' /></Button></Tooltip>
										{/* <Tooltip title='Delete'><Button onClick={() => handleOpenDeleteModal(val)}  ><DeleteIcon sx={{ fontSize: "32px" }} fontSize='large' color='error' /></Button></Tooltip> */}
										<Tooltip title='View Slides'><Button onClick={() => navigate(`/slides/${val.id}`, { state: val })}  ><VrpanoIcon sx={{ fontSize: "32px" }} fontSize='large' /></Button></Tooltip>
									</Box>
									{/* <ButtonCom onClickHandler={() => navigate(`/slides/${val.id}`, { state: val })} btnTitle={<VrpanoIcon fontSize='large' />} /> */}
								</Box>

							</Box>
						</Slide>
					</>
				})}
				{/* Banner Section */}
				<Typography variant="h5" className='font-face-R' sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>
					Banner
				</Typography>
				<Divider sx={{ mb: 2 }} />

				<Box style={styles.box}>
					<Typography className='font-face-R' variant="h6">Home Page Banner</Typography>
					<Tooltip title='Edit'><Button onClick={handleBannerModal}><EditIcon sx={{ fontSize: "32px" }} fontSize='large' /></Button></Tooltip>
				</Box>

				{/* Tutorial Video Section */}
				<Flex jc='space-between' ai='center' mt='4rem' mb='1rem'>
					<Typography variant="h5" className='font-face-R' sx={{ fontWeight: 'bold' }}>
						Tutorial Video
					</Typography>
					<ButtonCom onClickHandler={handleCreateTutorialModal} btnTitle={"Create"} />
				</Flex>
				<Divider sx={{ mb: 2 }} />
				{tutorialVideos?.map((val) => {
					return <>
						<Slide direction="right" in={tutorialVideos?.length > 0} mountOnEnter unmountOnExit key={val.id}>
							<Box style={styles.box}>
								<Box>
									<Typography className='font-face-R' variant="h4">{val.title}</Typography>
									<Typography fontSize={12} className='font-face-R' variant="body2">{val.video_url}</Typography>
								</Box>
								<Box>
									<Box>
										<Tooltip title='Status'><Switch onChange={(event) => handleChangeTutorialSwitch(event, val)} checked={val?.is_enabled} name='enabled' /></Tooltip>
										<Tooltip title='Edit'><Button onClick={() => handleEditTutorialModal(val)}><EditIcon sx={{ fontSize: "32px" }} fontSize='large' /></Button></Tooltip>
									</Box>
								</Box>
							</Box>
						</Slide>
					</>
				})}

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={modalName}
						isLoading={isLoadingModal}
					>
						{modalName === "Edit Banner" ?
							<div style={{ padding: "1em" }}>
								<img width="100%" src={bannerImage} />

								{isLoadingImg ?
									<CircularProgress sx={{ margin: "auto" }} color="success" />
									:
									<>
										<input
											accept=".jpeg, .jpg, .png"
											style={{ display: 'none' }}
											id="image-upload"
											type="file"
											onChange={(event) => handleImageUpload(event)}
										/>
										<label htmlFor="image-upload">
											<Button
												variant="contained"
												component="span"
												fullWidth
												color='success'
												style={{ fontSize: '1em' }}
											>
												Upload Image
											</Button>
										</label>

									</>}
								<Tooltip title='Status'><Switch onChange={(event) => handleChangeBannerSwitch(event)} checked={bannerStatus} name='enabled' /></Tooltip>

								<MarginHandler mt="2rem">
									<Button
										variant='contained'
										onClick={handleSubmitBanner}
										style={{
											background: colorGreenGradient,
											fontSize: '1.6rem',
											textTransform: 'none',
											padding: '0.7rem 2rem',
											color: colorWhite,
											borderRadius: '0.5rem',
											float: "right",
											marginBottom: "1em"
										}}
										className='font-face-R'>
										Update
									</Button>
								</MarginHandler>
							</div>
							:
							<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' margin='2.5rem 0' padding='2rem'>

								<MarginHandler width='100%'>
									<InputControl
										state={formData?.name}
										onChange={handleChange}
										// inputProps={{ maxLength: 60 }}
										label='Name'
										name='name'
										required
									/>
								</MarginHandler>
								<MarginHandler width='100%'>
									<InputControl
										state={formData?.description}
										onChange={handleChange}
										label='Description'
										// inputProps={{ maxLength: 120 }}
										name='description'
										multiline
										rows={1}
									/>
								</MarginHandler>

								<MarginHandler>
									<FormControlLabel control={<Checkbox sx={{
										'& .MuiSvgIcon-root': { fontSize: 22 }
									}} onChange={(e) => setShowTxtOnWeb(e.target.checked)} checked={showTxtOnWeb} />} label="Show Text on Website" />

								</MarginHandler>



								<MarginHandler mt="2rem">
									<Button
										variant='contained'
										onClick={handleSubmit}
										style={{
											background: colorGreenGradient,
											fontSize: '1.6rem',
											textTransform: 'none',
											padding: '0.7rem 2rem',
											color: colorWhite,
											borderRadius: '0.5rem',
											float: "right"
										}}
										disabled={!formData.name}
										className='font-face-R'>
										{isEditing ? "Update " : "Create "}
									</Button>
								</MarginHandler>

							</Grid>
						}
					</TransitionsModal>
				</Flex>






				{/* Tutorial Video Modal */}
				<TransitionsModal
					open={openTutorialModal}
					handleClose={handleCloseTutorialModal}
					modalTitle={isEditingTutorial ? "Edit Tutorial Video" : "Create Tutorial Video"}
					isLoading={isLoadingTutorialModal}
				>
					<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' margin='2.5rem 0' padding='2rem'>
						<MarginHandler width='100%'>
							<InputControl
								state={tutorialVideoFormData?.title}
								onChange={handleTutorialVideoChange}
								label='Title'
								name='title'
								required
							/>
						</MarginHandler>
						<MarginHandler width='100%'>
							<InputControl
								state={tutorialVideoFormData?.video_url}
								onChange={handleTutorialVideoChange}
								label='Video Link'
								name='video_url'
								required
							/>
						</MarginHandler>

						<MarginHandler mt="2rem">
							<Button
								variant='contained'
								onClick={handleSubmitTutorial}
								style={{
									background: colorGreenGradient,
									fontSize: '1.6rem',
									textTransform: 'none',
									padding: '0.7rem 2rem',
									color: colorWhite,
									borderRadius: '0.5rem',
									float: "right"
								}}
								disabled={!tutorialVideoFormData.title || !tutorialVideoFormData.video_url}
								className='font-face-R'>
								{isEditingTutorial ? "Update" : "Create"}
							</Button>
						</MarginHandler>
					</Grid>
				</TransitionsModal>

				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDeleteSlider}
				/>













			</Card>
		</>
	);
};

export default Slider;
